import React from 'react';
import { motion } from 'framer-motion';
import { Sun, CloudSun, Moon } from 'lucide-react';
export function PainSection() {
  const cards = [{
    icon: <Sun className="w-6 h-6 text-amber-500" data-id="element-267" />,
    title: 'Mañana',
    text: '«¡Apúrate! ¡Te lo dije! ¡Por favor! ¡Ya basta!» — Y solo son las 7:30am.',
    borderColor: 'border-amber-400'
  }, {
    icon: <CloudSun className="w-6 h-6 text-blue-500" data-id="element-268" />,
    title: 'Tarde',
    text: 'Cada tarea se convierte en negociación. Cada transición, en batalla.',
    borderColor: 'border-blue-400'
  }, {
    icon: <Moon className="w-6 h-6 text-indigo-500" data-id="element-269" />,
    title: 'Noche',
    text: '«Dormir» deja de ser descanso y se convierte en el conflicto final del día.',
    borderColor: 'border-indigo-400'
  }];
  return <section className="py-10 bg-white" data-id="element-270">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
        <div className="text-center mb-8" data-id="element-272">
          <span className="text-emerald-600 font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-273">
            Si esto te suena...
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 max-w-3xl mx-auto" data-id="element-274">
            Mañanas interminables. Tardes agotadoras. Noches eternas.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-275">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-2xl shadow-lg border-l-4 ${card.borderColor} hover:shadow-xl transition-shadow`} data-id="element-276">
              <div className="flex items-center gap-3 mb-4" data-id="element-277">
                {card.icon}
                <h3 className="text-xl font-bold text-stone-800" data-id="element-278">
                  {card.title}
                </h3>
              </div>
              <p className="text-stone-600 text-lg leading-relaxed" data-id="element-279">
                {card.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-amber-50 rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto border border-amber-100" data-id="element-280">
          <h3 className="text-2xl md:text-3xl font-bold text-stone-800 mb-4" data-id="element-281">
            Y lo más duro no es el cansancio. Es la culpa.
          </h3>
          <p className="text-xl text-stone-600 mb-6 italic" data-id="element-282">
            Esa sensación de: «Yo no quería gritar. ¿Por qué me cuesta tanto
            algo tan básico?»
          </p>
          <p className="text-lg font-semibold text-emerald-600" data-id="element-283">
            Si te suena... respira. No estás solo/a. Y lo mejor: esto tiene
            solución.
          </p>
        </motion.div>
      </div>
    </section>;
}